import { post } from './api'

export interface AlipayPagePayOrder {
  outTradeNo: string
  points: number
  amountYuan: string
  paymentHtml: string
}

export function createAlipayPagePay(points: number): Promise<AlipayPagePayOrder> {
  return post<AlipayPagePayOrder>('/payments/alipay/page-pay', { points })
}

export interface AlipayOrderStatus {
  outTradeNo: string
  status: string
  points: number
  amountYuan: string
  alipayTradeNo: string | null
}

export function queryAlipayOrder(outTradeNo: string): Promise<AlipayOrderStatus> {
  return post<AlipayOrderStatus>('/payments/alipay/query', { outTradeNo })
}
